import {
  InMemoryRefDataIndex,
  anyValueToIndexKey,
  createInMemoryRefDataIndex,
  InMemoryRefData,
  NoResultsError,
  MatchOperation,
  MatchArgs,
  findMatchingRow,
  findAllMatchingRows,
} from '@watershed/lscript/InMemoryRefData';
import { ReferenceDataSchemaDefinition } from '../referenceData/ReferenceDataSchemaInterface';

export type RefDataBundle = {
  fileMetadataId: string;
  gcsPath: { bucketName: string; remotePath: string };
  schema?: ReferenceDataSchemaDefinition;
  referenceDataSourceId: string;
  referenceTableVersionId: string;
  referenceTableRevisionId: string;
};

export type EvaluationRefDataMetadata = RefDataBundle & {
  // A unique key to identify this object. May be used as a cache key.
  key: string;

  // Columns in the reference data to fetch.
  cols: Array<string>;
};

export {
  type InMemoryRefDataIndex,
  anyValueToIndexKey,
  createInMemoryRefDataIndex,
  type InMemoryRefData,
  type NoResultsError,
  type MatchOperation,
  type MatchArgs,
  findMatchingRow,
  findAllMatchingRows,
};
